import React, { Component } from 'react';
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActions,
    Button
} from '@mui/material';
import {
    WhatsApp,
    ImageOutlined,
    FavoriteBorder,
    ReceiptLongOutlined,
    Inventory2Outlined,
    CalculateOutlined,
    ArrowForward
} from '@mui/icons-material';
import StraightenIcon from '@mui/icons-material/Straighten';
import QrCodeIcon from '@mui/icons-material/QrCode';
class Tools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tools: [
                {
                    id: 'whatsapp',
                    title: 'Gerador de Link WhatsApp',
                    description: 'Crie links personalizados com mensagens prontas para seus clientes iniciarem conversas com um clique.',
                    icon: <WhatsApp sx={{ color: '#25D366' }} />,
                    iconBg: '#E8F9EE',
                    actionUrl: '/ferramentas/whatsapp'
                },
                {
                    id: 'stories',
                    title: 'Gerador de Stories',
                    description: 'Crie stories profissionais para seus produtos com preços e selos de promoção em segundos.',
                    icon: <ImageOutlined sx={{ color: '#A21CAF' }} />,
                    iconBg: '#FDF4FF',
                    actionUrl: '/ferramentas/stories'
                },
                {
                    id: 'cartoes',
                    title: 'Gerador de Cartões',
                    description: 'Crie cartões de agradecimento, visita e cuidados com a peça para enviar junto com seus pedidos.',
                    icon: <FavoriteBorder sx={{ color: '#DB2777' }} />,
                    iconBg: '#FCE7F3',
                    actionUrl: '/ferramentas/cartoes'
                },
                {
                    id: 'recibo',
                    title: 'Gerador de Pedido/Recibo',
                    description: 'Crie documentos de venda profissionais em PDF para enviar aos seus clientes do WhatsApp.',
                    icon: <ReceiptLongOutlined sx={{ color: '#4F46E5' }} />,
                    iconBg: '#EEF2FF',
                    actionUrl: '/ferramentas/recibo'
                },
                {
                    id: 'etiquetas',
                    title: 'Gerador de Etiquetas',
                    description: 'Crie etiquetas de envio profissionais para Correios com remetente e destinatário prontos para imprimir.',
                    icon: <Inventory2Outlined sx={{ color: '#EA580C' }} />,
                    iconBg: '#FFEDD5',
                    actionUrl: '/ferramentas/etiquetas',
                    titleColor: '#4F46E5' // Destaque roxo sutil no título desta ferramenta como na imagem
                },
                {
                    id: 'margem',
                    title: 'Calculadora de Margem',
                    description: 'Descubra o preço de venda ideal para seus produtos considerando custos e lucro desejado.',
                    icon: <CalculateOutlined sx={{ color: '#2563EB' }} />,
                    iconBg: '#EFF6FF',
                    actionUrl: '/ferramentas/margem'
                },
                {
                    "id": "tabela-medidas",
                    "title": "Gerador de Tabela de Medidas",
                    "description": "Crie guias de medidas visuais e bonitos para postar no Instagram e reduzir dúvidas de tamanho.",
                    "icon": <StraightenIcon sx={{ color: '#DB2777' }} />,
                    "iconColor": "#DB2777",
                    "iconBg": "#FCE7F3",
                    "actionUrl": "/ferramentas/tabela-de-medidas",
                    "isComingSoon": false
                },
                {
                    "id": "qr-code",
                    "title": "Gerador de QR Code",
                    "description": "Crie QR Codes personalizados com sua logo e cores para imprimir em etiquetas e sacolas.",
                    "icon": <QrCodeIcon sx={{ color: '#0F172A' }} />,
                    "iconColor": "#0F172A",
                    "iconBg": "#F1F5F9",
                    "actionUrl": "/ferramentas/qr-code",
                    "isComingSoon": false
                },



            ]
        };
    }

    handleToolClick = (url) => {
        console.log(`Navegando para: ${url}`);
        // Se estiver usando react-router-dom: this.props.history.push(url);
    };

    render() {
        return (
            <Box sx={{ bgcolor: '#F8FAFC', minHeight: '100vh', py: 0 }}>


                {/* ================= HEADER ================= */}
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography
                        variant="h3"
                        component="h1"
                        sx={{
                            fontWeight: 900,
                            color: '#0F172A',
                            mb: 2,
                            fontSize: { xs: '2rem', md: '3rem' }
                        }}
                    >
                        Ferramentas Gratuitas para Lojistas
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#475569',
                            maxWidth: 600,
                            mx: 'auto',
                            lineHeight: 1.6,
                            fontSize: '1.1rem'
                        }}
                    >
                        Recursos práticos para ajudar você a vender mais, organizar seu negócio e profissionalizar sua presença online.
                    </Typography>
                </Box>

                {/* ================= GRID DE FERRAMENTAS ================= */}
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    {this.state.tools.map((tool) => (
                        <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                            <Card
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: 4,
                                    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.04)',
                                    border: '1px solid #E2E8F0',
                                    p: 2
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1, pb: 1 }}>
                                    {/* Container do Ícone */}
                                    <Box
                                        sx={{
                                            width: 48,
                                            height: 48,
                                            borderRadius: 3,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            bgcolor: tool.iconBg,
                                            mb: 3
                                        }}
                                    >
                                        {tool.icon}
                                    </Box>

                                    {/* Título da Ferramenta */}
                                    <Typography
                                        gutterBottom
                                        variant="h6"
                                        component="h1"
                                        sx={{
                                            fontWeight: 700,
                                            color: tool.titleColor || '#0F172A',
                                            mb: 1.5,
                                            fontSize: '1.2rem'
                                        }}
                                    >
                                        {tool.title}
                                    </Typography>

                                    {/* Descrição */}
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#475569',
                                            lineHeight: 1.6,
                                            fontSize: '0.925rem'
                                        }}
                                    >
                                        {tool.description}
                                    </Typography>
                                </CardContent>

                                {/* Ação do Card */}
                                <CardActions sx={{ pl: 2, pb: 2 }}>
                                    <Button
                                        variant="text"
                                        endIcon={<ArrowForward sx={{ fontSize: '1rem !important' }} />}
                                        onClick={() => this.handleToolClick(tool.actionUrl)}
                                        sx={{
                                            color: '#4F46E5',
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            fontSize: '0.95rem',
                                            p: 0,
                                            '&:hover': {
                                                bgcolor: 'transparent',
                                                color: '#3730A3'
                                            }
                                        }}
                                    >
                                        Acessar ferramenta
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>


            </Box>
        );
    }
}

export default Tools;